import type { MouseEvent, ReactNode } from 'react';
import { PickerTriggerButton } from '../../shared/picker/PickerTriggerButton';
import { PRIORITY_LEVELS, type PriorityLevel } from './priority.js';
import { NormalGlyph, HighGlyph, ExtremeGlyph } from './PriorityGlyphs.js';
import { PRIORITY_BUTTON_TONES, PRIORITY_CHEVRON_TONES } from './priorityTones.js';

interface PriorityTriggerProps {
    level: PriorityLevel;
    onClick: (e: MouseEvent) => void;
    ariaLabel?: string;
    tooltip?: ReactNode;
    compact?: boolean;
}

function TriggerGlyph({ level }: { level: PriorityLevel }) {
    if (level === 'high') return <HighGlyph className="text-amber-500" />;
    if (level === 'extreme') return <ExtremeGlyph className="text-white" />;
    return <NormalGlyph className="text-gray-400" />;
}

export function PriorityTriggerButton({
    level,
    onClick,
    ariaLabel,
    tooltip,
    compact
}: PriorityTriggerProps) {
    return (
        <PickerTriggerButton
            glyph={<TriggerGlyph level={level} />}
            label={PRIORITY_LEVELS[level].label}
            toneClassName={PRIORITY_BUTTON_TONES[level]}
            chevronClassName={PRIORITY_CHEVRON_TONES[level]}
            bold={level !== 'normal'}
            onClick={onClick}
            ariaLabel={ariaLabel}
            tooltip={tooltip}
            compact={compact}
        />
    );
}
